import * as React from "react";
import BarVisualization from "views/components/visualizations/bar/BarVisualization";
import BarVisualizationConfig, {
  DEFAULT_BARMODE
} from "views/logic/aggregationbuilder/visualizations/BarVisualizationConfig";
import { hasAtLeastOneMetric } from "views/components/visualizations/validations";
import {
  DEFAULT_AXIS_CONFIG,
  axisTypes,
  DEFAULT_AXIS_TYPE
} from "views/logic/aggregationbuilder/visualizations/XYVisualization";
import xyAxisConfigFields, { fromAxisConfig } from "views/components/visualizations/xyAxisConfigFields";
const validate = hasAtLeastOneMetric("Bar chart");
const barChart = {
  type: BarVisualization.type,
  displayName: "Bar Chart",
  component: BarVisualization,
  config: {
    createConfig: () => ({ barmode: DEFAULT_BARMODE, axisType: DEFAULT_AXIS_TYPE, axisConfig: DEFAULT_AXIS_CONFIG }),
    fromConfig: (config) => {
      var _a, _b;
      return {
        barmode: (_a = config == null ? void 0 : config.barmode) != null ? _a : DEFAULT_BARMODE,
        axisType: (_b = config == null ? void 0 : config.axisType) != null ? _b : DEFAULT_AXIS_TYPE,
        ...fromAxisConfig(config)
      };
    },
    toConfig: (formValues) => BarVisualizationConfig.create(
      formValues.barmode,
      formValues.axisType,
      formValues.showAxisLabels ? formValues.axisConfig : DEFAULT_AXIS_CONFIG
    ),
    fields: [
      {
        name: "barmode",
        title: "Mode",
        type: "select",
        options: [
          ["Group", "group"],
          ["Stack", "stack"],
          ["Relative", "relative"],
          ["Overlay", "overlay"]
        ],
        required: true,
        helpComponent: () => {
          const options = {
            group: {
              label: "Group",
              help: "Every series is represented by its own bar in the chart."
            },
            stack: {
              label: "Stack",
              help: "All series are stacked upon each other resulting in one bar."
            },
            relative: {
              label: "Relative",
              help: "All series are stacked upon each other resulting in one chart. But negative series are placed below zero."
            },
            overlay: {
              label: "Overlay",
              help: "All series are placed as bars upon each other. To be able to see the bars the opacity is reduced to 75%. It is recommended to use this option with not more than 3 series."
            }
          };
          return /* @__PURE__ */ React.createElement("ul", null, Object.values(options).map(({ label, help }) => /* @__PURE__ */ React.createElement("li", { key: label }, /* @__PURE__ */ React.createElement("h4", null, label), help)));
        }
      },
      {
        name: "axisType",
        title: "Axis Type",
        type: "select",
        options: axisTypes,
        required: true
      },
      ...xyAxisConfigFields
    ]
  },
  capabilities: ["event-annotations"],
  validate
};
export default barChart;
